import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import LiveOfficerMap from './LiveOfficerMap';

const API_URL = 'https://eapi.octaloptimum.in';

function getOfficerKey(officer) {
  return [
    officer?._id,
    officer?.userId,
    officer?.officerId
  ]
    .filter(Boolean)
    .map(String);
}

export default function LiveOfficersMapPage() {
  const [searchParams] = useSearchParams();

  const selectedOfficerId = searchParams.get('officerId');

  const [officer, setOfficer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const token =
    localStorage.getItem('accessToken') ||
    localStorage.getItem('token');

  useEffect(() => {
    if (!selectedOfficerId) {
      setError('Officer ID is missing.');
      setLoading(false);
      return;
    }

    if (!token) {
      setError('Admin authentication token is missing.');
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchOfficer = async () => {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(
          `${API_URL}/api/v1/admin/live-officers`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': token
            }
          }
        );

        const result = await response.json();

        if (!response.ok || result.status !== 1) {
          throw new Error(result.message || 'Unable to fetch officers.');
        }

        const officers = Array.isArray(result.data)
          ? result.data
          : result.data?.officers || [];

        const selected = officers.find(item =>
          getOfficerKey(item).includes(String(selectedOfficerId))
        );

        if (!selected) {
          throw new Error('Selected officer was not found.');
        }

        if (!cancelled) {
          setOfficer(selected);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Unable to load officer.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchOfficer();

    return () => {
      cancelled = true;
    };
  }, [selectedOfficerId, token]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-slate-950 text-white">
        Loading officer location...
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex items-center justify-center bg-slate-950 text-red-400">
        {error}
      </div>
    );
  }

  return (
    <div className="w-screen h-screen overflow-hidden">
      <LiveOfficerMap
        initialOfficer={officer}
        token={token}
      />
    </div>
  );
}